import React from "react";
import * as styles from "./news.module.scss";
import { useStaticQuery, graphql } from "gatsby";

import Layout from "@arbol/Layout";
import Footer from "@arbol/Footer";
import ContactForm from "@arbol/ContactForm";
import NewsPageBase from '@components/NewsPage';
import Seo from "@components/seo";
import { Helmet } from 'react-helmet';

function IndexPage() {
  const data = useStaticQuery(graphql`
    query news {
      allPrismicNewsPost(
        filter: {data: {page_selection: {eq: "Arbol"}}}
        sort: {order: DESC, fields: last_publication_date}
      ) {
        nodes {
          tags
          id
          data {
            featured
            external_link {
              url
              target
            }
            title {
              text
            }
            intro_text {
              text
            }
            author {
              text
              html
            }
            author_image {
              url
            }
            main_image {
              url
            }
            small_image {
              url
            }
            page_selection
          }
        }
      }
    }
  `);

  const newsPosts = data.allPrismicNewsPost.nodes;

  return (
    <Layout transparentHeader={false}>
      <Seo title="News | Arbol by Gomes" description="News and events happening at Arbol, downtown Newark’s newest modern living concept" />
      <Helmet>
        <meta property="og:title" content="Arbol by Gomes | Newark, NJ" />
        <meta property="og:description" content="Arbol by Gomes, Newark New Jersey’s newest modern apartment concept inspired by nature and built for more than living." />
        <meta property="og:image" content="https://images.prismic.io/bygomes/05121554-c7c7-4cf4-98f0-89884ff3f2ed_Arbol_lounge.jpg?ixlib=gatsbyFP&q=80&auto=compress%2Cformat&rect=0%2C0%2C792%2C593&w=793&h=594" />
        <meta property="og:url" content="https://bygomes.com/property/arbol" />
        <meta property="og:type" content="website" />
      </Helmet>    
      <NewsPageBase newsPosts={newsPosts} styles={styles} />
      <ContactForm />
      <Footer />
    </Layout>
  );
}

export default IndexPage;
